module.exports = __webpack_public_path__ + "static/media/ruble-sign.1d369f43.svg";